// extracted by mini-css-extract-plugin
export default {"arrow":"ScrollArrow_arrow__+MRrs","animate":"ScrollArrow_animate__fvxbt"};